import {
  WORK_ORDER_GET_TECH_ROUTE_STARTED,
  WORK_ORDER_GET_TECH_ROUTE_FINISHED,
  WORK_ORDER_GET_TECH_ROUTE_FAILED,
  WORK_ORDER_GET_STARTED,
  WORK_ORDER_GET_FINISHED,
  WORK_ORDER_GET_FAILED,
  WORK_ORDER_DETAIL_PAGE_OPENED,
  CLEAR_WORK_ORDER_DETAIL,
  SET_WORK_ORDER_SECTION_COLLAPSED,
  SET_SLIDE_INDEX,
  WORK_ORDER_BY_ORDER_ID_GET_STARTED,
  WORK_ORDER_BY_ORDER_ID_GET_FINISHED,
  WORK_ORDER_BY_ORDER_ID_GET_FAILED,
  SET_CLOSE_STEP,
  CLOSE_CODE_ADD,
  CLOSE_CODE_REMOVE,
  CLOSE_COMMENT_SET,
  TICKET_REQUEST_ADD,
  TICKET_REQUEST_REMOVE,
  CLOSE_ORDER_STATUS_SET,
  OUTLET_UPDATE,
  OUTLET_UPDATE_APPIAN_STARTED,
  OUTLET_UPDATE_APPIAN_FINISHED,
  OUTLET_UPDATE_APPIAN_FAILED,
  OUTLET_UPDATE_STARTED,
  OUTLET_UPDATE_FINISHED,
  OUTLET_UPDATE_FAILED,
  OUTLET_OPTIMIZATION_STATUS_SET,
  ORDER_CLOSE_STARTED,
  ORDER_CLOSE_WAITING,
  ORDER_CLOSE_FINISHED,
  ORDER_CLOSE_FAILED,
  ORDER_CLOSE_REQUEST_ADD_STARTED,
  ORDER_CLOSE_REQUEST_ADD_FINISHED,
  ORDER_CLOSE_REQUEST_ADD_FAILED,
  ORDER_HISTORY_REQUEST_STARTED,
  ORDER_HISTORY_REQUEST_FINISHED,
  ORDER_HISTORY_REQUEST_FAILED,
  TECH_HISTORY_REQUEST_STARTED,
  TECH_HISTORY_REQUEST_FINISHED,
  TECH_HISTORY_REQUEST_FAILED,
  SET_TECH_HISTORY_TECH_ID,
  SET_TECH_HISTORY_START_DATE,
  SET_TECH_HISTORY_END_DATE,
  SET_SHOW_ORDER_CLOSED,
  EQUIPMENT_HIT_STARTED,
  EQUIPMENT_HIT_FINISHED,
  EQUIPMENT_HIT_FAILED,
  EQUIPMENT_BALANCING_HIT_STARTED,
  EQUIPMENT_BALANCING_HIT_FINISHED,
  EQUIPMENT_BALANCING_HIT_FAILED,
  EQUIPMENT_REFRESH_HIT_STARTED,
  EQUIPMENT_REFRESH_HIT_FINISHED,
  EQUIPMENT_REFRESH_HIT_FAILED,
  TAG_UPDATE_STARTED,
  TAG_UPDATE_FINISHED,
  TAG_UPDATE_FAILED,
  SET_TAG_NUMBERS,
  SET_TAG_EDITING,
  SET_OUTLET_EXPANDED,
  EQUIPMENT_OPTION_QTY_SET,
  EQUIPMENT_OPTION_CLEAR,
  EQUIPMENT_OPTION_SUBMIT_STARTED,
  EQUIPMENT_OPTION_SUBMIT_FINISHED,
  EQUIPMENT_OPTION_SUBMIT_FAILED,
  UNPAIR_PAIR_STARTED,
  UNPAIR_PAIR_FINISHED,
  UNPAIR_PAIR_FAILED,
  SIGNATURE_CAPTURE_UPDATE,
  SET_NEW_CUSTOMER_EMAIL,
  SET_NEW_CUSTOMER_EMAIL_EDIT_MODE,
  RESET_CUSTOMER_EMAIL_EDIT,
  UPDATE_CUSTOMER_EMAIL_STARTED,
  UPDATE_CUSTOMER_EMAIL_FINISHED,
  UPDATE_CUSTOMER_EMAIL_FAILED,
  UPDATE_CUSTOMER_EMAIL_MESSAGE_RESET,
  GET_ADDRESS_FROM_BILLER_STARTED,
  GET_ADDRESS_FROM_BILLER_FINISHED,
  GET_ADDRESS_FROM_BILLER_FAILED,
  SET_TRUCK_ROLL_CLOSE_UNNECESSARY_VALUE,
  SET_TRUCK_ROLL_CLOSE_COMMENT,
  GET_HOME_VERIFY_STARTED,
  GET_HOME_VERIFY_FINISHED,
  GET_HOME_VERIFY_FAILED,
  SET_HOME_VERIFY_STARTED,
  SET_HOME_VERIFY_FINISHED,
  SET_HOME_VERIFY_FAILED,
  SET_HOME_VERIFY_STATE,
  SET_HOME_VERIFY_MESSAGE,
  PIN_RESET_STARTED,
  PIN_RESET_FINISHED,
  PIN_RESET_FAILED,
  PIN_RESET_RESET,
  SET_IN_HOME_ACCESS,
  SET_FST_SIGNAL_VALUE,
  GET_DIGITAL_CHANNELS_STARTED,
  GET_DIGITAL_CHANNELS_FINISHED,
  GET_DIGITAL_CHANNELS_FAILED,
  SET_TECHID_SIGNAL_LEVELS,
  SET_DELIVERY_PROOF_IMAGE,
  REMOVE_DELIVERY_PROOF_IMAGE,
  SET_DELIVERY_PROOF_DESCRIPTION,
  DELIVERY_PROOF_SUBMIT_STARTED,
  DELIVERY_PROOF_SUBMIT_FINISHED,
  DELIVERY_PROOF_SUBMIT_FAILED,
  DELIVERY_PROOF_INIT,
  ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED,
  ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED,
  ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED,
  SET_NOACCESS_REASON,
  GET_NOACCESS_REASONS_STARTED,
  GET_NOACCESS_REASONS_FINISHED,
  GET_NOACCESS_REASONS_FAILED,
  SET_DELIVERY_PROOF_BYPASS_FLAG,
  EQUIPMENT_ADD_BY_SERIAL_STARTED,
  EQUIPMENT_ADD_BY_SERIAL_FINISHED,
  EQUIPMENT_ADD_BY_SERIAL_FAILED,
  RESET_CPE_EQUIPMENT_ADD,
  TECH_WORK_ORDER_TRANSFER_STARTED,
  TECH_WORK_ORDER_TRANSFER_FINISHED,
  TECH_WORK_ORDER_TRANSFER_FAILED,
  CLEAR_WORK_ORDER_TRANSFER_STATE,
  DROP_BURY_SET,
} from 'constants/actionTypes';

export const workOrderGetTechRouteStarted = (request) => ({ type: WORK_ORDER_GET_TECH_ROUTE_STARTED, request });
export const workOrderGetTechRouteFinished = (payload, userId) => ({ type: WORK_ORDER_GET_TECH_ROUTE_FINISHED, payload, userId });
export const workOrderGetTechRouteFailed = (payload, userId) => ({ type: WORK_ORDER_GET_TECH_ROUTE_FAILED, payload, userId });
export const getWorkOrderStarted = (request, config) => ({ type: WORK_ORDER_GET_STARTED, request, config });
export const getWorkOrderFinished = (payload, key, orderId, timestamp = new Date()) => ({ type: WORK_ORDER_GET_FINISHED, payload, key, orderId, timestamp });
export const getWorkOrderFailed = (payload, key, orderId) => ({ type: WORK_ORDER_GET_FAILED, payload, key, orderId });
export const workOrderDetailPageOpened = (orderId, timestamp = new Date()) => ({ type: WORK_ORDER_DETAIL_PAGE_OPENED, orderId, timestamp });
export const clearWorkOrderDetail = (orderId, key, clearOutletUpdateMessage = false) => ({ type: CLEAR_WORK_ORDER_DETAIL, orderId, key, clearOutletUpdateMessage });
export const setWorkOrderSectionCollapsed = (orderId, key, isCollapsed) => ({ type: SET_WORK_ORDER_SECTION_COLLAPSED, orderId, key, isCollapsed });
export const setSlideIndex = (index, orderId) => ({ type: SET_SLIDE_INDEX, index, orderId });
export const workOrderByOrderIdGetStarted = (orderId) => ({ type: WORK_ORDER_BY_ORDER_ID_GET_STARTED, orderId });
export const workOrderByOrderIdGetFinished = (payload, orderId) => ({ type: WORK_ORDER_BY_ORDER_ID_GET_FINISHED, payload, orderId });
export const workOrderByOrderIdGetFailed = (payload, orderId) => ({ type: WORK_ORDER_BY_ORDER_ID_GET_FAILED, payload, orderId });
export const setCloseStep = (step, orderId) => ({ type: SET_CLOSE_STEP, step, orderId });
export const closeCodeAdd = (request, orderId) => ({ type: CLOSE_CODE_ADD, request, orderId });
export const closeCodeRemove = (request, orderId) => ({ type: CLOSE_CODE_REMOVE, request, orderId });
export const closeCommentSet = (request, orderId) => ({ type: CLOSE_COMMENT_SET, request, orderId });
export const dropBurySet = (value, orderId) => ({ type: DROP_BURY_SET, value, orderId });
export const ticketRequestAdd = (request, orderId) => ({ type: TICKET_REQUEST_ADD, request, orderId });
export const ticketRequestRemove = (workType, orderId) => ({ type: TICKET_REQUEST_REMOVE, workType, orderId });
export const closeOrderStatusSet = (orderStatus, orderId) => ({ type: CLOSE_ORDER_STATUS_SET, orderStatus, orderId });
export const outletOptimizationStatusSet = (optimizationStatus, orderId) => ({ type: OUTLET_OPTIMIZATION_STATUS_SET, optimizationStatus, orderId });
export const outletUpdate = (request) => ({ type: OUTLET_UPDATE, request });
export const outletUpdateAppianStarted = (orderId, accountNumber) => ({ type: OUTLET_UPDATE_APPIAN_STARTED, orderId, accountNumber });
export const outletUpdateAppianFinished = (response, orderId) => ({ type: OUTLET_UPDATE_APPIAN_FINISHED, response, orderId });
export const outletUpdateAppianFailed = (payload, orderId) => ({ type: OUTLET_UPDATE_APPIAN_FAILED, payload, orderId });
export const outletUpdateStarted = (request, orderId, userId, isSelf) => ({ type: OUTLET_UPDATE_STARTED, request, orderId, userId, isSelf });
export const outletUpdateFinished = (request, orderId, userId) => ({ type: OUTLET_UPDATE_FINISHED, request, orderId, userId });
export const outletUpdateFailed = (payload, orderId) => ({ type: OUTLET_UPDATE_FAILED, payload, orderId });
export const orderCloseStarted = (request, orderId) => ({ type: ORDER_CLOSE_STARTED, request, orderId });
export const orderCloseWaiting = (request, orderId) => ({ type: ORDER_CLOSE_WAITING, request, orderId });
export const orderCloseFinished = (payload, orderId) => ({ type: ORDER_CLOSE_FINISHED, payload, orderId });
export const orderCloseFailed = (payload, orderId) => ({ type: ORDER_CLOSE_FAILED, payload, orderId });
export const orderCloseRequestAddStarted = (request, orderId) => ({ type: ORDER_CLOSE_REQUEST_ADD_STARTED, request, orderId });
export const orderCloseRequestAddFinished = (payload, orderId) => ({ type: ORDER_CLOSE_REQUEST_ADD_FINISHED, payload, orderId });
export const orderCloseRequestAddFailed = (payload, orderId) => ({ type: ORDER_CLOSE_REQUEST_ADD_FAILED, payload, orderId });
export const setShowClosedOrders = (show) => ({ type: SET_SHOW_ORDER_CLOSED, show });
export const getOrderHistoryStarted = (request, orderId) => ({ type: ORDER_HISTORY_REQUEST_STARTED, request, orderId });
export const getOrderHistoryFinished = (payload, orderId) => ({ type: ORDER_HISTORY_REQUEST_FINISHED, payload, orderId });
export const getOrderHistoryFailed = (payload, orderId) => ({ type: ORDER_HISTORY_REQUEST_FAILED, payload, orderId });
export const getTechHistoryStarted = (techId, startDate, endDate) => ({ type: TECH_HISTORY_REQUEST_STARTED, techId, startDate, endDate });
export const getTechHistoryFinished = (payload, techId) => ({ type: TECH_HISTORY_REQUEST_FINISHED, payload, techId });
export const getTechHistoryFailed = (payload, techId) => ({ type: TECH_HISTORY_REQUEST_FAILED, payload, techId });
export const setTechHistoryTechId = (techId) => ({ type: SET_TECH_HISTORY_TECH_ID, techId });
export const setTechHistoryStartDate = (startDate) => ({ type: SET_TECH_HISTORY_START_DATE, startDate });
export const setTechHistoryEndDate = (endDate) => ({ type: SET_TECH_HISTORY_END_DATE, endDate });
export const equipmentHitStarted = (request, orderId) => ({ type: EQUIPMENT_HIT_STARTED, request, orderId });
export const equipmentHitFinished = (payload, request, orderId) => ({ type: EQUIPMENT_HIT_FINISHED, payload, request, orderId });
export const equipmentHitFailed = (payload, request, orderId) => ({ type: EQUIPMENT_HIT_FAILED, payload, request, orderId });
export const equipmentBalancingHitStarted = (request, orderId) => ({ type: EQUIPMENT_BALANCING_HIT_STARTED, request, orderId });
export const equipmentBalancingHitFinished = (payload, request, orderId) => ({ type: EQUIPMENT_BALANCING_HIT_FINISHED, payload, request, orderId });
export const equipmentBalancingHitFailed = (payload, request, orderId) => ({ type: EQUIPMENT_BALANCING_HIT_FAILED, payload, request, orderId });
export const equipmentRefreshHitStarted = (request, orderId) => ({ type: EQUIPMENT_REFRESH_HIT_STARTED, request, orderId });
export const equipmentRefreshHitFinished = (payload, request, orderId) => ({ type: EQUIPMENT_REFRESH_HIT_FINISHED, payload, request, orderId });
export const equipmentRefreshHitFailed = (payload, request, orderId) => ({ type: EQUIPMENT_REFRESH_HIT_FAILED, payload, request, orderId });
export const tagUpdateStarted = (request, orderId) => ({ type: TAG_UPDATE_STARTED, request, orderId });
export const tagUpdateFinished = (payload, orderId) => ({ type: TAG_UPDATE_FINISHED, payload, orderId });
export const tagUpdateFailed = (payload, orderId) => ({ type: TAG_UPDATE_FAILED, payload, orderId });
export const setTagNumbers = (tags, orderId) => ({ type: SET_TAG_NUMBERS, tags, orderId });
export const setTagEditing = (isEditing, orderId) => ({ type: SET_TAG_EDITING, isEditing, orderId });
export const setOutletExpanded = (isExpanded, orderId, outletId) => ({ type: SET_OUTLET_EXPANDED, isExpanded, orderId, outletId });
export const equipmentOptionQtySet = (orderId, optionCode, quantity) => ({ type: EQUIPMENT_OPTION_QTY_SET, orderId, optionCode, quantity });
export const equipmentOptionClear = (orderId) => ({ type: EQUIPMENT_OPTION_CLEAR, orderId });
export const equipmentOptionSubmitStarted = (request, orderId) => ({ type: EQUIPMENT_OPTION_SUBMIT_STARTED, request, orderId });
export const equipmentOptionSubmitFinished = (payload, orderId) => ({ type: EQUIPMENT_OPTION_SUBMIT_FINISHED, payload, orderId });
export const equipmentOptionSubmitFailed = (payload, orderId) => ({ type: EQUIPMENT_OPTION_SUBMIT_FAILED, payload, orderId });
export const unpairPairStarted = (request, orderId) => ({ type: UNPAIR_PAIR_STARTED, request, orderId });
export const unpairPairFinished = (payload, request, orderId) => ({ type: UNPAIR_PAIR_FINISHED, payload, request, orderId });
export const unpairPairFailed = (payload, request, orderId) => ({ type: UNPAIR_PAIR_FAILED, payload, request, orderId });
export const setNewCustomerEmail = (email, orderId, isLoginEmail = false) => ({ type: SET_NEW_CUSTOMER_EMAIL, email, orderId, isLoginEmail });
export const setCustomerEmailEditMode = (value, orderId, isLoginEmail = false) => ({ type: SET_NEW_CUSTOMER_EMAIL_EDIT_MODE, value, orderId, isLoginEmail });
export const resetCustomerEmailChanges = (orderId, isLoginEmail = false) => ({ type: RESET_CUSTOMER_EMAIL_EDIT, orderId, isLoginEmail });
export const updateCustomerEmailStarted = (request, orderId, isLoginEmail = false) => ({ type: UPDATE_CUSTOMER_EMAIL_STARTED, request, orderId, isLoginEmail });
export const updateCustomerEmailFinished = (payload, orderId, isLoginEmail = false) => ({ type: UPDATE_CUSTOMER_EMAIL_FINISHED, payload, orderId, isLoginEmail });
export const updateCustomerEmailFailed = (payload, status, orderId, isLoginEmail = false) => ({ type: UPDATE_CUSTOMER_EMAIL_FAILED, payload, orderId, status, isLoginEmail });
export const updateCustomerEmailMessageReset = (orderId) => ({ type: UPDATE_CUSTOMER_EMAIL_MESSAGE_RESET, orderId });

export const getAddressFromBillerStarted = (request, orderId) => ({ type: GET_ADDRESS_FROM_BILLER_STARTED, request, orderId });
export const getAddressFromBillerFinished = (payload, orderId) => ({ type: GET_ADDRESS_FROM_BILLER_FINISHED, payload, orderId });
export const getAddressFromBillerFailed = (payload, orderId) => ({ type: GET_ADDRESS_FROM_BILLER_FAILED, payload, orderId });

export const signatureCaptureUpdate = (request, orderId) => ({ type: SIGNATURE_CAPTURE_UPDATE, request, orderId });
export const setTruckRollUnecessaryValue = (value, orderId) => ({ type: SET_TRUCK_ROLL_CLOSE_UNNECESSARY_VALUE, value, orderId });
export const setTruckRollCloseComment = (comment, orderId) => ({ type: SET_TRUCK_ROLL_CLOSE_COMMENT, comment, orderId });

export const getHomeVerifyStarted = (request, config) => ({ type: GET_HOME_VERIFY_STARTED, request, config });
export const getHomeVerifyFinished = (payload, orderId, timestamp = new Date()) => ({ type: GET_HOME_VERIFY_FINISHED, payload, orderId, timestamp });
export const getHomeVerifyFailed = (payload, orderId) => ({ type: GET_HOME_VERIFY_FAILED, payload, orderId });
export const setHomeVerifyStarted = (request, config) => ({ type: SET_HOME_VERIFY_STARTED, request, config });
export const setHomeVerifyFinished = (payload, orderId) => ({ type: SET_HOME_VERIFY_FINISHED, payload, orderId });
export const setHomeVerifyFailed = (payload, orderId) => ({ type: SET_HOME_VERIFY_FAILED, payload, orderId });

export const setHomeVerifyState = (orderId, homeVerifyState) => ({ type: SET_HOME_VERIFY_STATE, orderId, homeVerifyState });
export const setHomeVerifyMessage = (orderId, message) => ({ type: SET_HOME_VERIFY_MESSAGE, orderId, message });

export const setFstSignalValue = (request, orderId) => ({ type: SET_FST_SIGNAL_VALUE, request, orderId });
export const getDigitalChannelsStarted = (marketId, orderId) => ({ type: GET_DIGITAL_CHANNELS_STARTED, marketId, orderId });
export const getDigitalChannelsFinished = (request, orderId) => ({ type: GET_DIGITAL_CHANNELS_FINISHED, request, orderId });
export const getDigitalChannelsFailed = (request, orderId) => ({ type: GET_DIGITAL_CHANNELS_FAILED, request, orderId });
export const setTechIdSignalLevels = (payload, orderId) => ({ type: SET_TECHID_SIGNAL_LEVELS, payload, orderId });

export const setDeliveryProofImage = (payload, orderId) => ({ type: SET_DELIVERY_PROOF_IMAGE, payload, orderId });
export const removeDeliveryProofImage = (orderId) => ({ type: REMOVE_DELIVERY_PROOF_IMAGE, orderId });
export const setDeliveryProofDescription = (request, orderId) => ({ type: SET_DELIVERY_PROOF_DESCRIPTION, request, orderId });
export const setDeliveryProofBypassFlag = (request, orderId) => ({ type: SET_DELIVERY_PROOF_BYPASS_FLAG, request, orderId });

export const deliveryProofSubmitStarted = (request, orderId) => ({ type: DELIVERY_PROOF_SUBMIT_STARTED, request, orderId });
export const deliveryProofSubmitFinished = (request, orderId) => ({ type: DELIVERY_PROOF_SUBMIT_FINISHED, orderId });
export const deliveryProofSubmitFailed = (request, orderId) => ({ type: DELIVERY_PROOF_SUBMIT_FAILED, request, orderId });

export const initDeliveryProof = (payload, orderId) => ({ type: DELIVERY_PROOF_INIT, payload, orderId });

export const setNoAccessReason = (payload, orderId) => ({ type: SET_NOACCESS_REASON, payload, orderId });
export const getNoAccessReasonListStarted = (orderId) => ({ type: GET_NOACCESS_REASONS_STARTED, orderId });
export const getNoAccessReasonListFinished = (payload, orderId) => ({ type: GET_NOACCESS_REASONS_FINISHED, payload, orderId });
export const getNoAccessReasonListFailed = (payload, orderId) => ({ type: GET_NOACCESS_REASONS_FAILED, payload, orderId });

export const addEquipmentBySerialStarted = (payload, path, orderId) => ({type: EQUIPMENT_ADD_BY_SERIAL_STARTED, payload, path, orderId});
export const addEquipmentBySerialFinished = (payload, path, orderId) => ({type: EQUIPMENT_ADD_BY_SERIAL_FINISHED, payload, path, orderId}); 
export const addEquipmentBySerialFailed = (payload, path, orderId) => ({type: EQUIPMENT_ADD_BY_SERIAL_FAILED, payload, path, orderId}); 
export const resetCpeEquipmentAdd = (path, orderId) => ({type: RESET_CPE_EQUIPMENT_ADD, path, orderId});

export const transferWorkOrderStarted = (techId, orderId) => ({type: TECH_WORK_ORDER_TRANSFER_STARTED, techId, orderId});
export const transferWorkOrderFinished = (payload, orderId) => ({type: TECH_WORK_ORDER_TRANSFER_FINISHED, payload, orderId}); 
export const transferWorkOrderFailed = (error, orderId) => ({type: TECH_WORK_ORDER_TRANSFER_FAILED, error, orderId}); 
export const clearWorkOrderTransferState = () => ({type: CLEAR_WORK_ORDER_TRANSFER_STATE});


export const pinResetStarted = (orderId, request) => ({
  type: PIN_RESET_STARTED,
  orderId,
  request,
});

export const pinResetFinished = (orderId, response, pinType) => ({
  type: PIN_RESET_FINISHED,
  orderId,
  response,
  pinType,
});

export const pinResetFailed = (orderId, error, pinType) => ({
  type: PIN_RESET_FAILED,
  orderId,
  error,
  pinType,
});

export const pinResetReset = (orderId, pinTypes) => ({
  type: PIN_RESET_RESET,
  orderId,
  pinTypes,
});

export const markOrderInHomeAccessNeededAs = (value, orderId) => ({
  type: SET_IN_HOME_ACCESS,
  value,
  orderId
});

export const asurionPlusEnrollmentSubmitStarted = (request, orderId) => ({
  type: ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED,
  request,
  orderId
});
export const asurionPlusEnrollmentSubmitFinished = (payload, orderId) => ({
  type: ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED,
  orderId
});
export const asurionPlusEnrollmentSubmitFailed = (payload, orderId) => ({
  type: ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED,
  payload,
  orderId
});



// WEBPACK FOOTER //
// ./src/actions/workOrderActions.js